import React from 'react';
import Loader from 'react-loader-spinner';

import PropTypes from 'prop-types';

import { Button, Anchor } from './styles';

export default function ButtonComponent({ label, loading, program, largeButton, disabled, ...props }) {
  const { as, href, icon, ...rest } = props;

  if (as === 'a') {
    return (
      <Anchor href={href} disabled={loading}>
        {loading ? (
          <Loader type="ThreeDots" color="#fff" height={15} width={40} />
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {icon} &nbsp; {label}
          </div>
        )}
      </Anchor>
    );
  }

  return (
    <Button program={program} {...rest} loading={loading} disabled={disabled || loading} largeButton={largeButton}>
      {loading ? (
        <Loader type="ThreeDots" color="#fff" height={15} width={40} />
      ) : (
        <span style={{ display: 'flex', alignItems: 'center' }}>{label}</span>
      )}
    </Button>
  );
}

ButtonComponent.propTypes = {
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  largeButton: PropTypes.bool,
  program: PropTypes.string,
  as: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.element,
};

ButtonComponent.defaultProps = {
  loading: false,
  program: 'cnhpop',
  as: 'button',
  href: '',
  icon: null,
};
